// extracted by mini-css-extract-plugin
module.exports = {"support":"support--Support-paywalls-components__kkXSb","button":"button--Support-paywalls-components__3qc4I","description":"description--Support-paywalls-components__CDmIw"};